import { render, staticRenderFns } from "./FormDirectory.vue?vue&type=template&id=2008ca70&scoped=true"
import script from "./FormDirectory.vue?vue&type=script&lang=js"
export * from "./FormDirectory.vue?vue&type=script&lang=js"
import style0 from "./FormDirectory.vue?vue&type=style&index=0&id=2008ca70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008ca70",
  null
  
)

export default component.exports